
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { UmbralesService } from 'src/app/modulos/catalogos-proces/services/umbrales.service';
import { Component, ChangeDetectorRef, Input, ViewChild, OnInit, ElementRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map, mergeMap} from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';
import { AlertService } from 'src/app/services/alert.service';
import { IndicadoresService } from '../../../services/indicadores.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormArray, FormControl, FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfiguracionIndicadoresService } from '../../../services/configuracion-indicadores.service';
import { EspecialUnoService } from 'src/app/modulos/catalogos-proces/services/especial-uno.service';
import { EspecialDosService } from 'src/app/modulos/catalogos-proces/services/especial-dos.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { DatePipe } from '@angular/common';
import { CumpleIndicadorService } from 'src/app/modulos/elementos-plan/services/cumple-indicador.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ObjetivoService } from 'src/app/modulos/elementos-plan/services/objetivo.service';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
import { EstrategiaObjetivoService } from '../../../services/estrategia-objetivo.service';
import { AgrupacionIndicadoresService } from 'src/app/modulos/elementos-plan/services/agrupacion-indicadores.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import * as FileSaver from 'file-saver';
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from 'rxjs/operators';
import { CLIENT_RENEG_LIMIT } from 'tls';

@Component({
  selector: 'app-config-agrupa-indicadores',
  templateUrl: './config-agrupa-indicadores.component.html',
  styleUrls: ['./config-agrupa-indicadores.component.css']
})
export class ConfigAgrupaIndicadoresComponent {

  nameApp = ' CONFIGURACIÓN-INDICADOR';
  nameApp1 = ' ';
  nameApp2 = ' METAS-INDICADOR';
  nameApp3 = ' CUMPLIMIENTO-INDICADOR';
  public modalConfigIndicador: string = 'modalConfigIndicador';
  public modalIngresoMetas: string = 'modalIngresoMetas';
  public modalEditMetas: string = 'modalEditMetas'
  public modalAgrupaIndicadores: string = 'agrupaIndicadores';
  public modalFormularioAgrupacion: string = 'modalFormularioAgrupacion';
  public modalCumpleIndicadorNumDeno: string = 'modalCumpleIndicadorNumDeno';
  public modalCumpleIndicadorComentario: string = 'modalCumpleIndicadorComentario';
  public modalCumpleIndicadorNumerador: string = 'modalCumpleIndicadorNumerador';
  public eliminaAgrupacionIndicador: string = 'eliminaAgrupacionIndicador';

  public formConfiguracionIndicadores!: UntypedFormGroup;
  public formAgrupacionIndicador!: UntypedFormGroup;
  public formCreaIndicadorAdmin!: UntypedFormGroup;
  public formCumpleIndicador!: UntypedFormGroup;
  public formCumpleIndicadorComentario!: UntypedFormGroup;
  public formCumpleIndicadorNumerador!: UntypedFormGroup;

  public formSubmitted = false;
  public currentAmbiente: any;
  public ipAddress!: string;
  public buffer: any;
  public dataConfiguracionIndicadores: any[] = [];
  public dataUmbrales!: any;
  public dataJerarquiaCatalogo!: any; // trae data catalogo especial uno Jeraquia
  public dataFrecuencia!: any; // trae data catalogo especial uno Jeraquia
  public dataTipoAgrupacion!: any;// trae data catalogo especial dos tipo de agrupacion  //
  public idSprEspecialDos: number = 0;
  public nombreTipoAgrupacion: string = "";
  public nombreTipoAgrupacion2: string = "";
  public nombreExpresion2: string = "";
  public verifycIndicadorHijo: any[] = []
  public nombreUnidad!: any;
  public nombreIndicador!: any;
  public idSprConfigIndicador!: any;
  private idDeleteRegister: number = 0;
  private id_SprCumpleIndicador: number = 0;
  private idSprCumpleIndicador: number = 0;
  public idPeriodoHijo: number = 0;
  public selectItems: any[] = [];
  public archivoCapturado: any[] = [];
  public selectCumplir: any[] = [];
  public selectAgrupacion: any[] = [];
  titulosConfigIndicador: any[] = [];
  submitted: boolean = false;
  cumplimientoIndicador: string = 'false';
  idSprAmbiente!: number;
  public nivelSelect!: number;
  public periodos!: any;
  public dataMapCumpleIndicador: any[] = [];
  public dataMapCumpleIndicadorNew: any[] = [];
  public dataOrdenaMapCumpleIndicador: any[] = [];
  public dataAgrupacionCalculos: any[] = []
  public dataMapConfigIndicador: any[] = [];
  public dataFrecuenciaCatalogo: any[] = [];
  public dataExpresionCatalogo: any[] = [];
  public expresionCatalogo: any[] = [];
  public tipoIndCatalogo: any[] = [];
  public dataTipoIndicadorCatalogo: any[] = [];
  public dataUniMedidaEspecialDos: any[] = [];
  public dataComportamientoCatalogo: any[] = [];
  public dataIndicador: any[] = [];
  private idSprIndicadorPadre: number;
  private idSprTipoAgrupacionCalculo: number;
  public periodo: any;
  public dataCumpleIndicador: any[] = [];
  public dataObjetivo: any[] = [];
  public dataEstrategiaObjetivo: any[] = [];
  public dataAmbientesInferior: any[] = [];
  public dataIndicadorInferior: any[] = [];
  public dataConfigIndicadorHijo: any[] = [];
  public dataConfigIndicadorPadre: any[] = [];
  public dataAgrupacionIndicador: any[] = [];
  public dataAgrupacion: any;
  public listAgrupacionIndicador: any[] = [];
  public dataObjetivoEstrategiaPadre: any[] = [];
  public listIndicador: any[] = [];
  public listObjetivo: any[] = [];
  public listAmbiente: any[] = [];
  public dataMapAgrupacionIndicador: any[] = [];
  public dataReplicaIndicadores: any[] = [];
  public dataCumpleMetaIndicadorPadre: any[] = [];
  public dataCumpleMetaIndicadorPadre1: any[] = [];
  public dataCumpleMetaIndicadorHijo: any[] = [];
  public lengthIndicadoresAgrupados = 0;
  public lengthIndicadoresAgrupados2 = 0;
  public openlabelValor: boolean = false;
  public openlabelTipoAgrupacion: boolean = false;
  public openNumero: boolean = false;
  public openPorcentaje: boolean = false;
  public openBanda: boolean = false;
  public openTiempo: boolean = false;
  public openVariacion: boolean = false;
  public desahabilitarInput: boolean = true
  public dasactivarCamposFormConfig: boolean = false;
  public dasactivarCamposFormMeta: boolean = false;
  public identificadorUnidadMedida: any
  public metasPeriodos: any
  public idLineaAccionHabilitarCampo: boolean = true;
  public idPlanAccionHabilitarCampo: boolean = true;
  public idProyectoHabilitarCampo: boolean = true;
  public idProcesoHabilitarCampo: boolean = true;
  idSprIndicador: number = 0;
  public getDataMapMetaIndicador: any[] = [];
  public respDataPeriodosCumple: any[] = []
  isDeleting = false;

  public planAnioSeleccionadoRedux: any = null;
  public idSprPlanAnio: number = 0;
  public idSprAnio: number = 0;
  public idSprNivel: number = 0;
  public idSprRolPrincipal: number = 0;
  public openFechaFin: boolean = false
  public lineaBaseMetaIndicador: any;

  readonly constant = ConstantsCatalogosIdService;

  currentUser!: any;
  hoy = new Date();
  pipe = new DatePipe('en-US');
  disableSelect = new FormControl(this.dasactivarCamposFormConfig);

  bitesMaximoPdf = ConstantsCatalogosIdService.BIT_MAXIMO_PDF_CUMPLE_INDICADOR;
  idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5;
  idSprComunCatalogoFrecuencia = ConstantsCatalogosIdService.ID_COMUNES_FRECUENCIA;
  idSprComunCatalogoExpresion = ConstantsCatalogosIdService.ID_COMUNES_EXPRESION_INDICADOR;
  idSprComunCatalogoComportamiento = ConstantsCatalogosIdService.ID_COMUNES_COMPORTAMIENTO;
  idRecursivoJerarquia = ConstantsCatalogosIdService.ID_ESPECIAL_UNO_JERARQUIA;
  idRecursivoTipoIndicador = ConstantsCatalogosIdService.ID_ESPECIAL_UNO_TIPO_INDICADOR;
  idSprEspecial2UnidadMedia = ConstantsCatalogosIdService.ID_ESPECIAL_DOS_UNIDAD_DE_MEDIDA;
  idSprTipoAgrupacionEspecialDos = ConstantsCatalogosIdService.ID_ESPECIAL_DOS_AGRUPACION;
  idRolObservador = ConstantsCatalogosIdService.OBSERVADOR;
  idRolLinderMetodologico = ConstantsCatalogosIdService.LIDER_METODOLOGICO;
  idRolAnalistaMetodologico = ConstantsCatalogosIdService.ANALISTA_METODOLOGICO;


  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @ViewChild('myInput')
  myInputVariable: ElementRef;


  @Input() set init(dataIndicador: any) {
    if (dataIndicador.idSprLineaAccion != null && dataIndicador.idSprLineaAccion !== undefined) {
      this.idLineaAccionHabilitarCampo = false;
    } else {
      this.idLineaAccionHabilitarCampo = true;
    }
    if (dataIndicador.idSprPlanAccion != null && dataIndicador.idSprPlanAccion !== undefined) {
      this.idPlanAccionHabilitarCampo = false;
    } else {
      this.idPlanAccionHabilitarCampo = true;
    }
    if (dataIndicador.idSprProyecto != null && dataIndicador.idSprProyecto !== undefined) {
      this.idProyectoHabilitarCampo = false;
    } else {
      this.idProyectoHabilitarCampo = true;
    }
    if (dataIndicador.idSprProceso != null && dataIndicador.idSprProceso !== undefined) {
      this.idProcesoHabilitarCampo = false;
    } else {
      this.idProcesoHabilitarCampo = true;
    }
    this.idSprIndicador = dataIndicador.idSprIndicador;
    this.dataIndicador = dataIndicador;
    this.nameApp1 = dataIndicador;
    this.nameApp1 = dataIndicador.nombre;
    this.initApp();
    this.getIpPublic();
  }

  @Input() set initLongitud(lengthIndicadoresAgrupados: any) {
    this.lengthIndicadoresAgrupados2 = lengthIndicadoresAgrupados;
  }

  @Input() set initTipoAgrupa(nombreTipoAgrupacion: any) {
    this.nombreTipoAgrupacion2 = nombreTipoAgrupacion;
  }

  @Input() set initExpresion(nombreExpresion: any) {
    this.nombreExpresion2 = nombreExpresion;
  }


  constructor(
    private fb: FormBuilder,
    private configuracionIndicadoresService: ConfiguracionIndicadoresService,
    private indicadoresService: IndicadoresService,
    private alert: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private comunService: ComunService,
    private especialUnoService: EspecialUnoService,
    private especialDosService: EspecialDosService,
    private cumpleIndicadorService: CumpleIndicadorService,
    private sanitizer: DomSanitizer,
    private objetivoService: ObjetivoService,
    private estrategiaObjetivoService: EstrategiaObjetivoService,
    private ambientesService: AmbienteService,
    private cdr: ChangeDetectorRef,
    private agrupacionIndicadoresService: AgrupacionIndicadoresService,
    public store: Store<AppState>,
    private spinner: NgxSpinnerService
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentAmbiente.nombreUnidad;
    this.currentUser = JSON.parse(this.buffer);
    this.idSprAmbiente = this.currentUser.idSprAmbiente;
    this.titulosConfigIndicador = [{
      nombreFrecuencia: '',
      nombreTipo: '',
      nombreExpresion: '',
      nombreUnidadMedida: '',
      nombreComportamiento: ''
    }];

    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.selectCumplir = [
      { value: 'S', label: 'SI' },
      { value: 'N', label: 'NO' },
    ];
    this.selectAgrupacion = [
      { value: 1, label: 'SI' },
      { value: 2, label: 'NO' },
    ];
    this.idSprAmbiente = this.currentAmbiente.idSprAmbiente;
  }


  get procesoForm() {
    return this.formConfiguracionIndicadores.controls;
  }
  get creaAgrupacionIndForm() {
    return this.formAgrupacionIndicador.controls;
  }


  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  setForm() {
    this.formConfiguracionIndicadores = this.fb.group({
      idSprConfigIndicador: [],
      idSprIndicador: [this.idSprIndicador],
      idSprUnidadMedida: ['', [Validators.required]],
      idSprComportamiento: ['', [Validators.required]],
      idSprExpresion: [],
      idSprFrecuencia: ['', [Validators.required]],
      idSprJerarquia: ['', [Validators.required]],
      idSprTipoIndicador: ['', [Validators.required]],
      idSprTipoAgrupacion: [],
      formula: [''],
      lineaBase: ['', [Validators.required]],
      estado: ['', [Validators.required]],
    });

    this.formAgrupacionIndicador = this.fb.group({
      idSprAgrupaIndicador: [],
      idSprAmbiente: ['', [Validators.required]],
      idSprObjetivo: ['', [Validators.required]],
      idSprIndicadorPadre: [],
      idSprIndicadorHijo: ['', [Validators.required]],
      valor: [],
    });

    this.formCreaIndicadorAdmin = this.fb.group({
      idSprCumpleIndicador: [''],
      nombrePeriodo: [''],
      metasPeriodos: this.fb.array([]),
      metaPeriodo: ['', [Validators.required]],
      periodo: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
    });

    this.formCumpleIndicador = this.fb.group({
      idSprCumpleIndicador: [],
      idPeriodo: [],
      comentario: ['', [Validators.required]],
      respaldoPdf: ['', [Validators.required]],
      numerador: ['50', [Validators.required]],
      denominador: ['', [Validators.required]],
      cumplido: [],
      fechaCumplimiento: [],
    });

    this.formCumpleIndicadorComentario = this.fb.group({
      idSprCumpleIndicador: [],
      comentario: ['', [Validators.required]],
      respaldoPdf: ['', [Validators.required]],
      cumplido: [],
      fechaCumplimiento: [],
    });

    this.formCumpleIndicadorNumerador = this.fb.group({
      idSprCumpleIndicador: [],
      comentario: ['', [Validators.required]],
      respaldoPdf: ['', [Validators.required]],
      numerador: ['', [Validators.required]],
      cumplido: [],
      fechaCumplimiento: [],
    });
  }

  initApp() {
    this.store.select('globalApp').subscribe(response => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.idSprAnio = response.planAniosSeleccionado.idSprAnio;
      this.idSprRolPrincipal = response.rolSeleccionado.idSprRol;
    })

    this.getIpPublic();
    this.listAgrupacion();
    this.listConfiguracionIndicadores();
    this.setDataTable();
    this.setForm();
    this.listTipoAgrupacion();
    this.listFrecuencia();
    this.listAmbientesInferiores();
    this.listEstrategiaObjetivo();
  }

  get getMetas() {
    return this.formCreaIndicadorAdmin.get('metasPeriodos') as FormArray
  }

  addMetas() {
    const metasFormGroup = this.fb.group({
      metaPeriodo: ['']
    })
    this.getMetas.push(metasFormGroup);
  }

  /**
   * método  listAmbientesInferiores() para listar los ambientes de nivel inferior
   */

  listAmbientesInferiores() {
    this.ambientesService.list('?spr_idSprAmbiente=' + this.idSprAmbiente + '&estado=' + 1).subscribe((resp) => {
      this.dataAmbientesInferior = resp;
    });
  }

  /**
 * método listEstrategiaObjetivo() para listar los objetivos relacionados a las estrategias de nivel superior
 */
  listEstrategiaObjetivo() {
    this.estrategiaObjetivoService.list().subscribe((resp) => {
      this.dataEstrategiaObjetivo = resp;
    });
  }

  /**
   * metodo obtenerObjetivos() para obtener los objetivos de nivel inferior relacionados a los Ambientes
   */
  obtenerObjetivos(event: any) {
    this.dataObjetivo = [0]
    this.dataIndicadorInferior = [0]
    let dataObjetivo = []
    let idSprObjetivoAnterior: number = 0
    if (event) {
      this.formSubmitted = true;
      this.objetivoService.list('?idSprAmbiente=' + event).subscribe(data => {
        data.forEach(resp => {
          for (let i = 0; i < this.dataEstrategiaObjetivo.length; i++) {
            for (let j = 0; j < this.dataObjetivoEstrategiaPadre.length; j++) {
              if (
                (this.dataEstrategiaObjetivo[i].idSprObjetivo == resp.idSprObjetivo) &&
                (this.dataEstrategiaObjetivo[i].idSprEstrategia == this.dataObjetivoEstrategiaPadre[j].idSprEstrategiaPadre) &&
                (this.dataEstrategiaObjetivo[i].nivelSuperior == "S") && (idSprObjetivoAnterior != resp.idSprObjetivo)) {
                idSprObjetivoAnterior = resp.idSprObjetivo
                dataObjetivo.push(resp)
              }
            }
          }
        }
        )
        this.dataObjetivo = dataObjetivo
        if (this.dataObjetivo.length == 0) {
          this.alert.warning(
            '¡Atención!',
            'No se encuentra OBJETIVIOS ALINEADOS, de la unidad seleccionada.'
          );
        }
      })
    }
    // this.cdr.detectChanges();
  }

  /**
   * método para obtener los indicadores de nivel inferior, mediante el Id del Objetivo
   */
  obtenerIndicadores(event: any) {

    if (event) {
      this.indicadoresService.list('?idSprObjetivo=' + event).subscribe(data => {
        this.dataIndicadorInferior = data
      })
    }
    //this.cdr.detectChanges();
  }

  /**
   * Método para comparar la configuración de los inidcadores de nivel superior con los
   * indicadores de nivel inferior
   */
  comparaConfiguracion(idSprIndicadorHijo: any) {
    if (idSprIndicadorHijo) {
      forkJoin([
        this.configuracionIndicadoresService.list(`?idSprIndicador=${idSprIndicadorHijo}`),
        this.configuracionIndicadoresService.list(`?idSprIndicador=${this.idSprIndicadorPadre}`),
      ]).pipe(map(
        ([
          configIndicadorHijo,
          configIndicadorPadre,
        ]) => {
          this.dataConfigIndicadorHijo = configIndicadorHijo;
          this.dataConfigIndicadorPadre = configIndicadorPadre;
        })).subscribe();

    }
    this.cdr.detectChanges();
  }

  comparaConfigIndicador() {
    if (this.dataConfigIndicadorHijo.length > 0) {
      if (this.dataConfigIndicadorPadre[0].idSprFrecuencia == this.dataConfigIndicadorHijo[0].idSprFrecuencia) {
      } else {
      }
    } else {
      this.alert.warning(
        '¡Atención!',
        'El indicador seleccionado no tiene configuración.'
      );
    }
  }

  /**
   * Método para validad el tipo de agrupación segun SI es agrupado o NO
  */
  openTipoAgrupacion(event: any) {
    if (event) {
      if (event == 1) {
        this.openlabelTipoAgrupacion = true;
        //this.formConfiguracionIndicadores.value.idSprTipoAgrupacion = 1;
      } else {
        this.openlabelTipoAgrupacion = false;
        //this.formConfiguracionIndicadores.value.formula = 2;
        this.formConfiguracionIndicadores.value.idSprTipoAgrupacion = null;
      }
    }
  }

  /**
   * Método para validar segun el tipo de agrupación seleccionada 
   */
  obtenerTipoAgrupacion(event: any) {
    let dataTipoAgrupacion
    if (event) {
      this.especialDosService.list(event).subscribe(data => {
        dataTipoAgrupacion = data
        if (dataTipoAgrupacion.formula == 'SUMA-P') {
          this.openlabelValor = true;
        } else {
          this.openlabelValor = false;
        }
      })
    }
    this.cdr.detectChanges();
  }

  /**
   * Metodo para obtener la expecion segun la unidad de medida
   */
  obtenerExpreson(event: any) {
    this.expresionCatalogo = [0]
    this.dataExpresionCatalogo
    if (event) {
      this.especialDosService.list(event).subscribe(data => {

        if ((data.formula == "NUMERO") || (data.formula == "VARIACION")) {
          for (let i = 0; i < this.dataExpresionCatalogo.length; i++) {
            if (this.dataExpresionCatalogo[i].nombre == "NO FRACCIONAL") {
              this.expresionCatalogo = [this.dataExpresionCatalogo[i]]
            }
          }
        } else {
          for (let j = 0; j < this.dataExpresionCatalogo.length; j++) {
            if (this.dataExpresionCatalogo[j].nombre != "NO FRACCIONAL") {
              this.expresionCatalogo = [this.dataExpresionCatalogo[j]]
            }
          }
          //return;
        }

        if (data.formula == "BANDA") {
          this.tipoIndCatalogo = [0]
          for (let x = 0; x < this.dataTipoIndicadorCatalogo.length; x++) {
            
            if (this.dataTipoIndicadorCatalogo[x].descripcion == "BANDA") {
              this.tipoIndCatalogo = [this.dataTipoIndicadorCatalogo[x]]
              this.formConfiguracionIndicadores.patchValue({
                idSprTipoIndicador: this.dataTipoIndicadorCatalogo[x].idSprEspecialUno,
                nombreTipo: this.dataTipoIndicadorCatalogo[x].nombre,
              });
            }
          }
        } else { 
          this.tipoIndCatalogo = []
          for (let y = 0; y < this.dataTipoIndicadorCatalogo.length; y++) {
            if ((this.dataTipoIndicadorCatalogo[y].descripcion == "ASCENDENTE") || (this.dataTipoIndicadorCatalogo[y].descripcion == "DESCENDENTE")) {
              this.tipoIndCatalogo.push(this.dataTipoIndicadorCatalogo[y])
            }
          }
        }
      })
    }
    //this.cdr.detectChanges();
  }

  /**
   * Método para guarda la agrupación de indicadores
   */

  crearAgrupacionIndicador() {
    this.formSubmitted = true;
    let dataAgrupacionIndicador = {
      idSprIndicadorPadre: this.idSprIndicadorPadre,
      idSprIndicadorHijo: this.formAgrupacionIndicador.value.idSprIndicadorHijo,
      idSprTipoAgrupacionCalculo: this.idSprTipoAgrupacionCalculo,
      valor: this.formAgrupacionIndicador.value.valor,
      estado: 1,
      usuario: this.currentUser.idSprUsuario,
      ip: this.ipAddress,
    };
    if (this.formAgrupacionIndicador.valid) {
      if (this.dataConfigIndicadorHijo.length != 0) {
        // if (resp.length == 0) {
        if (this.dataConfigIndicadorPadre[0].idSprFrecuencia == this.dataConfigIndicadorHijo[0].idSprFrecuencia) {
          if (this.dataConfigIndicadorPadre[0].idSprComportamiento == this.dataConfigIndicadorHijo[0].idSprComportamiento) {
            if (this.dataConfigIndicadorPadre[0].idSprUnidadMedida == this.dataConfigIndicadorHijo[0].idSprUnidadMedida) {
              if ((this.dataConfigIndicadorPadre[0].idSprTipoIndicador == this.dataConfigIndicadorHijo[0].idSprTipoIndicador)) {
                if (this.formAgrupacionIndicador.value.idSprAgrupaIndicador == null || this.formAgrupacionIndicador.value.idSprAgrupaIndicador == ' ') {
                  this.agrupacionIndicadoresService.list(`?idSprIndicadorHijo=${this.formAgrupacionIndicador.value.idSprIndicadorHijo}`).subscribe({
                    next: (resp) => {
                      if (resp.length == 0) {
                        this.agrupacionIndicadoresService.create(dataAgrupacionIndicador)
                          .subscribe(
                            (resp) => {
                              this.initApp();
                              this.listAgrupacionIndicadores();
                              this.closeModalFormularioAgrupacion();
                              this.alert.createOk();
                            },
                            (err) => {
                              this.alert.createError();
                            }
                          );
                      } else {
                        this.alert.warning(
                          '¡Atención!',
                          'El indicador seleccionado ya se encuantra agrupado, seleccione otro indicador.'
                        );
                        return;
                      }
                    }
                  })

                } else {
                  this.agrupacionIndicadoresService.list(`?idSprIndicadorHijo=${this.formAgrupacionIndicador.value.idSprIndicadorHijo}`).subscribe({
                    next: (resp) => {

                      if (resp.length > 0) {
                        if ((resp[0].idSprIndicadorHijo == this.formAgrupacionIndicador.value.idSprIndicadorHijo) && (resp[0].idSprIndicadorPadre == this.idSprIndicadorPadre)) {
                          this.agrupacionIndicadoresService.update(this.formAgrupacionIndicador.value)
                            .subscribe(
                              (resp) => {
                                this.initApp();
                                this.listAgrupacionIndicadores();
                                this.closeModalFormularioAgrupacion();
                                this.alert.updateOk();
                              },
                              (err) => {
                                this.alert.updateError();
                              }
                            );
                        }
                      } else {
                        if (resp.length == 0) {
                          this.agrupacionIndicadoresService.update(this.formAgrupacionIndicador.value)
                            .subscribe(
                              (resp) => {
                                this.initApp();
                                this.listAgrupacionIndicadores();
                                this.closeModalFormularioAgrupacion();
                                this.alert.updateOk();
                              },
                              (err) => {
                                this.alert.updateError();
                              }
                            );
                        } else {
                          this.alert.warning(
                            '¡Atención!',
                            'El indicador seleccionado ya se encuantra agrupado, seleccione otro indicador.'
                          );
                          return;
                        }
                      }
                    }
                  })

                }/*** */
              } else {
                this.alert.warning(
                  '¡Atención!',
                  'El indicador seleccionado no tiene el mismo TIPO DE INDICADOR.'
                );
              }
            } else {
              this.alert.warning(
                '¡Atención!',
                'El indicador seleccionado no tiene la misma UNIDAD DE MEDIDA.'
              );
            }
          } else {
            this.alert.warning(
              '¡Atención!',
              'El indicador seleccionado no tiene la mismo COMPORTAMIENTO.'
            );
          }
        } else {
          this.alert.warning(
            '¡Atención!',
            'El indicador seleccionado no tiene la misma FRECUENCIA.'
          );
        }
        // } 

      } else {
        this.alert.warning(
          '¡Atención!',
          'El indicador seleccionado no tiene configuración.'
        );
      }
    } else {
      //return true;
    }
  }

  verificarAgrupacionIndicador() {
    this.agrupacionIndicadoresService.list("?idSprIndicadorHijo" + this.formAgrupacionIndicador.value.idSprIndicadorHijo).subscribe(resp => {
      this.verifycIndicadorHijo = resp;
      if (resp.length > 0) {
      } else {
      }
    })
  }

  /**
   * método para listar los indicadores agrupados 
   */

  listAgrupacionIndicadores() {
    forkJoin([
      this.agrupacionIndicadoresService.list(`?idSprIndicadorPadre=${this.idSprIndicadorPadre}`),
      this.indicadoresService.list(),
      this.objetivoService.list(),
      this.ambientesService.list(),
    ]).pipe(map(
      ([
        agrupacionIndicador, indicadores, objetivos, ambientes
      ]) => {
        this.listAgrupacionIndicador = agrupacionIndicador;
        this.listIndicador = indicadores;
        this.listObjetivo = objetivos;
        this.listAmbiente = ambientes;
        this.mapAgrupacionIndicadores();
      })).subscribe();
  }

  mapAgrupacionIndicadores() {
    let dataProcess: any = [];
    for (let i = 0; i < this.listAgrupacionIndicador.length; i++) {
      for (let j = 0; j < this.listIndicador.length; j++) {
        if (this.listAgrupacionIndicador[i].idSprIndicadorHijo == this.listIndicador[j].idSprIndicador) {
          for (let k = 0; k < this.listObjetivo.length; k++) {
            if (this.listObjetivo[k].idSprObjetivo == this.listIndicador[j].idSprObjetivo) {
              for (let l = 0; l < this.listAmbiente.length; l++) {
                if (this.listAmbiente[l].idSprAmbiente == this.listObjetivo[k].idSprAmbiente) {
                  dataProcess.push({
                    idSprAmbiente: this.listAmbiente[l].idSprAmbiente,
                    idSprObjetivo: this.listObjetivo[k].idSprObjetivo,
                    idSprAgrupaIndicador: this.listAgrupacionIndicador[i].idSprAgrupaIndicador,
                    idSprIndicadorPadre: this.listAgrupacionIndicador[i].idSprIndicadorPadre,
                    idSprIndicadorHijo: this.listAgrupacionIndicador[i].idSprIndicadorHijo,
                    idSprTipoAgrupacionCalculo: this.listAgrupacionIndicador[i].idSprTipoAgrupacionCalculo,
                    valor: this.listAgrupacionIndicador[i].valor,
                    nombreIndicadorHijo: this.listIndicador[j].nombre,
                    nombreAmbienteHijo: this.listAmbiente[l].nombreUnidad,
                    estado: this.listAmbiente[l].estado,
                  });
                }
              }
            }
          }
        }
      }
    }
    this.dataMapAgrupacionIndicador = dataProcess  
  }

crearMetaPeriodo(dataMapMetaIndicador: any) {
  //this.spinner.show();

  const dataMetasPeriodos = dataMapMetaIndicador.map((metaIndicador, i) => ({
    idSprCumpleIndicador: metaIndicador.idSprCumpleIndicador,
    idSprConfigIndicador: this.idSprConfigIndicador,
    idPeriodo: metaIndicador.idPeriodo,
    cumplido: 'N',
    metaPeriodo: this.formCreaIndicadorAdmin.value.metasPeriodos[i]?.metaPeriodo,
    estado: 1,
    usuario: this.currentUser.idSprUsuario,
    ip: this.ipAddress,
  }));

  this.dataCumpleMetaIndicadorHijo = dataMetasPeriodos;

      this.cumpleIndicadorService.updateBulk(dataMetasPeriodos).subscribe(
      (resp) => {
        this.alert.updateOk();
        this.modal.closeId(this.modalIngresoMetas);
        this.initApp();
      },
      (err) => {
       this.alert.updateError();
      }
    );
}

  editarMetaPeriodo() {
    let dataMetaPeriodo: any;

    if (this.idSprRolPrincipal == this.idRolAnalistaMetodologico) {
      dataMetaPeriodo = {
        idSprCumpleIndicador: this.formCreaIndicadorAdmin.value.idSprCumpleIndicador,
        metaPeriodo: this.formCreaIndicadorAdmin.value.metaPeriodo,
        fechaFin: this.formCreaIndicadorAdmin.value.fechaFin,
        usuario: this.currentUser.idSprUsuario,
        ip: this.ipAddress,
      };
    } else {
      dataMetaPeriodo = {
        idSprCumpleIndicador: this.formCreaIndicadorAdmin.value.idSprCumpleIndicador,
        metaPeriodo: this.formCreaIndicadorAdmin.value.metaPeriodo,
        usuario: this.currentUser.idSprUsuario,
        ip: this.ipAddress,
      };
    }


    if (this.formCreaIndicadorAdmin.value.idSprCumpleIndicador != null || this.formCreaIndicadorAdmin.value.idSprCumpleIndicador != ' ') {
      this.cumpleIndicadorService.update(dataMetaPeriodo)
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId(this.modalEditMetas);
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      // return true;          
    }
  }

  /**
 * Método para validar el indicador segun la configuracion del campo Unidad de Medida => 
 * banda de tolerancia, numero y porcentaje
 */

  obtenerUnidadMedia(dataConfig: any) {
    let identificadorUnidadMedida: any
    this.titulosConfigIndicador[0].formulaUnidadMedida = dataConfig.formulaUnidadMedida;
    identificadorUnidadMedida = this.titulosConfigIndicador[0].formulaUnidadMedida

    if (identificadorUnidadMedida == 'NUMERO') {
      this.openNumero = true;
    }
    if (identificadorUnidadMedida == 'PORCENTAJE') {
      this.openPorcentaje = true;
    }
    if (identificadorUnidadMedida == 'BANDA') {
      this.openBanda = true;
    }
    if (identificadorUnidadMedida == 'VARIACION') {
      this.openVariacion = true;
    }
    if (identificadorUnidadMedida == 'TIEMPO') {
      this.openTiempo = true;
    }
    this.cdr.detectChanges();
  }


  listConfiguracionIndicadores() {
    this.clearNameConfigIndicador();
    if (this.idSprIndicador) {
      this.configuracionIndicadoresService
        .list('?idSprIndicador=' + this.idSprIndicador + '&estado=' + 1)
        .subscribe((resp) => {
          this.dataConfiguracionIndicadores = resp;
          this.listCumpleIndicadores();
        });
    }
  }

  listCumpleIndicadores() {
    this.cumpleIndicadorService.list().subscribe((resp) => {
      this.dataCumpleIndicador = resp;
      this.listElementosComun();
    });
  }

  listElementosComun() {
    this.clearCamposConfigIndicador();
    forkJoin([
      this.comunService.list(`?spr_idSprComun=${this.idSprComunCatalogoFrecuencia}`),
      this.comunService.list(`?spr_idSprComun=${this.idSprComunCatalogoExpresion}`),
      this.comunService.list(`?spr_idSprComun=${this.idSprComunCatalogoComportamiento}`),
      this.especialUnoService.list(`?spr_idSprEspecialUno=${this.idRecursivoTipoIndicador}`),
      this.especialUnoService.list(`?spr_idSprEspecialUno=${this.idRecursivoJerarquia}`),
      this.especialDosService.list(`?spr_idSprEspecialDos=${this.idSprEspecial2UnidadMedia}`),
      this.especialDosService.list(`?spr_idSprEspecialDos=${this.idSprTipoAgrupacionEspecialDos}`),
    ]).pipe(map(
      ([frecuencia, expresion, comportamiento, tipoIndicador, jerarquia, unidadMedida, tipoAgrupacion
      ]) => {
        this.dataFrecuenciaCatalogo = frecuencia;
        this.dataExpresionCatalogo = expresion;
        this.dataComportamientoCatalogo = comportamiento;
        this.dataTipoIndicadorCatalogo = tipoIndicador;
        this.dataJerarquiaCatalogo = jerarquia;
        this.dataUniMedidaEspecialDos = unidadMedida;
        this.dataTipoAgrupacion = tipoAgrupacion;

        this.mapIndicadorCumple();
      })).subscribe();
  }

  mapIndicadorCumple() {
    let dataMapConfigIndicador: any = [];
    let dataCumpleIndicador: any = [];
    let getFrecuencia: any = [];
    let getExpresion: any = [];
    let getComportamiento: any = [];
    let getTipo: any = [];
    let getUnidadMedida: any = [];
    
    for (let i = 0; i < this.dataConfiguracionIndicadores.length; i++) {
      for (let j = 0; j < this.dataFrecuenciaCatalogo.length; j++) {
        if (this.dataConfiguracionIndicadores[i].idSprFrecuencia == this.dataFrecuenciaCatalogo[j].idSprComun) {
          getFrecuencia.push({
            idSprFrecuencia:
              this.dataConfiguracionIndicadores[i].idSprFrecuencia,
            nombreFrecuencia: this.dataFrecuenciaCatalogo[j].nombre,
            frecuencia: this.dataFrecuenciaCatalogo[j].descripcion.split(','),
          });
        }
      }
      for (let k = 0; k < this.dataExpresionCatalogo.length; k++) {
        if (this.dataConfiguracionIndicadores[i].idSprExpresion ==  this.dataExpresionCatalogo[k].idSprComun ) {
          getExpresion.push({
            idSprExpresion: this.dataConfiguracionIndicadores[i].idSprExpresion,
            nombreExpresion: this.dataExpresionCatalogo[k].nombre,
          });
        }
      }
      for (let k = 0; k < this.dataComportamientoCatalogo.length; k++) {
        if (
          this.dataConfiguracionIndicadores[i].idSprComportamiento ==
          this.dataComportamientoCatalogo[k].idSprComun
        ) {
          getComportamiento.push({
            idSprComportamiento:
              this.dataConfiguracionIndicadores[i].idSprComportamiento,
            comportamiento: this.dataComportamientoCatalogo[k].nombre,
          });
        }
      }
      for (let k = 0; k < this.dataTipoIndicadorCatalogo.length; k++) {
        if (this.dataConfiguracionIndicadores[i].idSprTipoIndicador == this.dataTipoIndicadorCatalogo[k].idSprEspecialUno) 
          {
          getTipo.push({
            idSprTipoIndicador: this.dataConfiguracionIndicadores[i].idSprTipoIndicador,
            nombreTipo: this.dataTipoIndicadorCatalogo[k].nombre,
          });
        }
      }
      for (let k = 0; k < this.dataUniMedidaEspecialDos.length; k++) {
        if (this.dataConfiguracionIndicadores[i].idSprUnidadMedida == this.dataUniMedidaEspecialDos[k].idSprEspecialDos) {
          getUnidadMedida.push({
            idSprUnidadMedida: this.dataConfiguracionIndicadores[i].idSprUnidadMedida,
            unidadMedida: this.dataUniMedidaEspecialDos[k].nombre,
            formulaUnidadMedida: this.dataUniMedidaEspecialDos[k].formula,
          });
        }
      }

      dataMapConfigIndicador.push({
        idSprConfigIndicador: this.dataConfiguracionIndicadores[i].idSprConfigIndicador,
        idSprIndicador: this.dataConfiguracionIndicadores[i].idSprIndicador,
        idSprUnidadMedida: this.dataConfiguracionIndicadores[i].idSprUnidadMedida,
        idSprComportamiento: this.dataConfiguracionIndicadores[i].idSprComportamiento,
        idSprExpresion: this.dataConfiguracionIndicadores[i].idSprExpresion,
        idSprFrecuencia: this.dataConfiguracionIndicadores[i].idSprFrecuencia,
        idSprJerarquia: this.dataConfiguracionIndicadores[i].idSprJerarquia,
        idSprTipoIndicador: this.dataConfiguracionIndicadores[i].idSprTipoIndicador,
        idSprTipoAgrupacion: this.dataConfiguracionIndicadores[i].idSprTipoAgrupacion,
        lineaBase: this.dataConfiguracionIndicadores[i].lineaBase,
        formula: this.dataConfiguracionIndicadores[i].formula,
        estado: this.dataConfiguracionIndicadores[i].estado,
        nombreFrecuencia: getFrecuencia[i].nombreFrecuencia,
        frecuencia: getFrecuencia[i].frecuencia,
        nombreExpresion: getExpresion[i].nombreExpresion,
        nombreTipo: getTipo[i].nombreTipo,
        comportamiento: getComportamiento[i].comportamiento,
        unidadMedida: getUnidadMedida[i].unidadMedida,
        formulaUnidadMedida: getUnidadMedida[i].formulaUnidadMedida,
        nombreJerarquia: this.dataConfiguracionIndicadores[i].nombre,
      });
      for (let l = 0; l < this.dataCumpleIndicador.length; l++) {
        if (
          this.dataConfiguracionIndicadores[i].idSprConfigIndicador ==
          this.dataCumpleIndicador[l].idSprConfigIndicador
        ) {
          dataCumpleIndicador.push({
            idSprCumpleIndicador: this.dataCumpleIndicador[l].idSprCumpleIndicador,
            idSprConfigIndicador: this.dataCumpleIndicador[l].idSprConfigIndicador,
            idPeriodo: this.dataCumpleIndicador[l].idPeriodo,
            nombre: this.dataCumpleIndicador[l].nombre,
            metaPeriodo: this.dataCumpleIndicador[l].metaPeriodo,
            numerador: this.dataCumpleIndicador[l].numerador,
            denominador: this.dataCumpleIndicador[l].denominador,
            fechaInicio: this.dataCumpleIndicador[l].fechaInicio,
            fechaFin: this.dataCumpleIndicador[l].fechaFin,
            cumplido: this.dataCumpleIndicador[l].cumplido,
            respaldoPdf: this.dataCumpleIndicador[l].respaldoPdf,

          });
        }
      }
    }
    this.dataMapCumpleIndicador = dataCumpleIndicador;
    this.dataOrdenaMapCumpleIndicador = this.dataMapCumpleIndicador.sort((a, b) => a.idPeriodo - b.idPeriodo);
    dataCumpleIndicador = [];
    this.dataMapConfigIndicador = dataMapConfigIndicador;
    if (this.dataMapConfigIndicador.length != 0) {
      this.viewDataConfig(this.dataMapConfigIndicador[0]);
      this.idSprIndicadorPadre = this.dataMapConfigIndicador[0].idSprIndicador;
      const hojasConIdRelacionado = this.encontrarHojasConIdRelacionado(this.idSprIndicadorPadre, this.dataAgrupacion);
      this.getDataHojas(hojasConIdRelacionado)
    }
  }

  listAgrupacion() {
    this.agrupacionIndicadoresService.list().subscribe(
      response => {
        this.dataAgrupacion = response;
      }
    )
  }

  encontrarHojasConIdRelacionado(idNodo, arreglo) {
    const hojas = [];
    arreglo.forEach(objeto => {
      if (objeto.idSprIndicadorPadre === idNodo) {
        const hojasHijo = this.encontrarHojasConIdRelacionado(objeto.idSprIndicadorHijo, arreglo);
        hojas.push(...hojasHijo);
      }
    });
    if (hojas.length === 0) {
      // Si no se encontraron hijos, este nodo es una hoja
      hojas.push({ id: idNodo });
    }
    return hojas;
  }

  async getDataHojas(uniqueArray = []) {
    let dataAgupacionIndicador = [];
    this.dataCumpleMetaIndicadorPadre1 = []
    for (let a = 0; a < uniqueArray.length; a++) {
      this.agrupacionIndicadoresService.list(`?idSprIndicadorHijo=${uniqueArray[a].id}`).subscribe(dataAgrupaIndicador => {
        dataAgrupaIndicador.forEach(resp => {
          this.configuracionIndicadoresService.list(`?idSprIndicador=${resp.idSprIndicadorHijo}`).subscribe(dataConfig => {
            dataConfig.forEach(resp2 => {
              this.cumpleIndicadorService.list(`?idSprConfigIndicador=${resp2.idSprConfigIndicador}`).subscribe(dataCumple => {

                dataAgupacionIndicador.push({
                  dataCumple: dataCumple,
                  dataConfig: resp2,
                  valor: resp.valor
                })
                this.dataCumpleMetaIndicadorPadre1 = dataAgupacionIndicador;
              })
            })
          })
        })
      })
    }
  }

  creMetasResultadosIndicadores() {
    this.idSprEspecialDos = this.dataMapConfigIndicador[0].idSprTipoAgrupacion;
    if (this.idSprEspecialDos != null) {
      this.especialDosService.list(`${this.idSprEspecialDos}`).subscribe(respTipo => {
        this.nombreTipoAgrupacion = respTipo.formula
        this.mostrarCrearMetasIndicadores()
      })
    }
  }

  mostrarCrearMetasIndicadores() {
    let dataMetaResultado: any = [];
    let dataMetaResultadoPush: any = [];
    let totalDataMetasResultados: any = []
    if (this.nombreTipoAgrupacion == "SUMA-P") {
      for (let i = 0; i < this.dataCumpleMetaIndicadorPadre1.length; i++) {
        for (let j = 0; j < this.dataCumpleMetaIndicadorPadre1[i].dataCumple.length; j++) {
          dataMetaResultado = {
            idPeriodo: this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].idPeriodo,
            metaPeriodo: (this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].metaPeriodo) * (this.dataCumpleMetaIndicadorPadre1[i].valor),
            numerador: this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].numerador,
            denominador: this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].denominador,
            valor: this.dataCumpleMetaIndicadorPadre1[i].valor,
          }
          dataMetaResultadoPush.push(dataMetaResultado)
        }
      }
    } else {
      for (let i = 0; i < this.dataCumpleMetaIndicadorPadre1.length; i++) {
        for (let j = 0; j < this.dataCumpleMetaIndicadorPadre1[i].dataCumple.length; j++) {
          dataMetaResultado = {
            idPeriodo: this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].idPeriodo,
            metaPeriodo: (this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].metaPeriodo),
            numerador: this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].numerador,
            denominador: this.dataCumpleMetaIndicadorPadre1[i].dataCumple[j].denominador,
            valor: this.dataCumpleMetaIndicadorPadre1[i].valor,
          }
          dataMetaResultadoPush.push(dataMetaResultado)
        }
      }
    }

    totalDataMetasResultados = dataMetaResultadoPush.reduce((acumulador, valorActual) => {
      const elementoYaExiste = acumulador.find(elemento => elemento.idPeriodo === valorActual.idPeriodo);
      if (elementoYaExiste) {

        return acumulador.map((elemento) => {
          if (elemento.idPeriodo === valorActual.idPeriodo) {
            if (this.nombreTipoAgrupacion == "SUMATORIA") {
              return {
                ...elemento,
                metaPeriodo: elemento.metaPeriodo + valorActual.metaPeriodo,
                numerador: elemento.numerador + valorActual.numerador,
                denominador: elemento.denominador + valorActual.denominador,
              }
            }
            if (this.nombreTipoAgrupacion == "PROMEDIO") {
              return {
                ...elemento,
                metaPeriodo: elemento.metaPeriodo + valorActual.metaPeriodo,
                numerador: elemento.numerador + valorActual.numerador,
                denominador: elemento.denominador + valorActual.denominador,
              }
            }
            if (this.nombreTipoAgrupacion == "SUMA-P") {
              return {
                ...elemento,
                metaPeriodo: elemento.metaPeriodo + valorActual.metaPeriodo,
                numerador: elemento.numerador + valorActual.numerador,
                denominador: elemento.denominador + valorActual.denominador,
              }
            }
          }
          return elemento;
        });
      } else {
        totalDataMetasResultados = dataMetaResultadoPush
      }
      return [...acumulador, valorActual];
    }, []);
    if (this.dataCumpleMetaIndicadorPadre1.length > 0) {
      this.calculosMetasResultados(this.dataMapCumpleIndicador, totalDataMetasResultados)
    } else {
      this.alert.warning(
        '¡Atención!',
        'No existe indicadores agrupados.'
      );
    }

  }

  calculosMetasResultados(dataMapMetaIndicador: any, totalDataMetasResultados: any) {
    let operaciones: any;
    let numeroIndicadores: any;
    let totalDataMetasCalculadas: any = [];
    numeroIndicadores = this.lengthIndicadoresAgrupados2
    if (this.nombreTipoAgrupacion == "SUMATORIA") {

      if (this.titulosConfigIndicador[0].nombreExpresion == "NO FRACCIONAL") {
        for (let j = 0; j < totalDataMetasResultados.length; j++) {
          operaciones = {
            idPeriodo: totalDataMetasResultados[j].idPeriodo,
            metaPeriodo: (totalDataMetasResultados[j].metaPeriodo),
            numerador: (totalDataMetasResultados[j].numerador),
          }
          totalDataMetasCalculadas.push(operaciones)
        }
      } else {
        for (let j = 0; j < totalDataMetasResultados.length; j++) {
          operaciones = {
            idPeriodo: totalDataMetasResultados[j].idPeriodo,
            metaPeriodo: (totalDataMetasResultados[j].metaPeriodo / numeroIndicadores),
            denominador: (totalDataMetasResultados[j].denominador),
            numerador: (totalDataMetasResultados[j].numerador),
          }
          totalDataMetasCalculadas.push(operaciones)
        }
      }
    }

    if (this.nombreTipoAgrupacion == "PROMEDIO") {
      for (let j = 0; j < totalDataMetasResultados.length; j++) {
        operaciones = {
          idPeriodo: totalDataMetasResultados[j].idPeriodo,
          metaPeriodo: (totalDataMetasResultados[j].metaPeriodo / numeroIndicadores),
          denominador: (totalDataMetasResultados[j].denominador / numeroIndicadores),
          numerador: (totalDataMetasResultados[j].numerador / numeroIndicadores),
        }
        totalDataMetasCalculadas.push(operaciones)
      }
    }

    if (this.nombreTipoAgrupacion == "SUMA-P") {
      for (let j = 0; j < totalDataMetasResultados.length; j++) {
        operaciones = {
          idPeriodo: totalDataMetasResultados[j].idPeriodo,
          metaPeriodo: (totalDataMetasResultados[j].metaPeriodo),
          denominador: (totalDataMetasResultados[j].denominador),
          numerador: (totalDataMetasResultados[j].numerador),
        }
        totalDataMetasCalculadas.push(operaciones)
      }
    }
    this.crearReplicaMetaPeriodo(dataMapMetaIndicador, totalDataMetasCalculadas)
  }

  crearReplicaMetaPeriodo(dataMapMetaIndicador: any, totalDataMetasResultados: any) {
    let dataMetaPeriodo
    let dataMetasPeriodos = []
    for (let i = 0; i < dataMapMetaIndicador.length; i++) {
      for (let j = 0; j < totalDataMetasResultados.length; j++) {
        if ((i < dataMapMetaIndicador.length) && (totalDataMetasResultados[j].idPeriodo == dataMapMetaIndicador[i].idPeriodo)) {
          dataMetaPeriodo = {
            idSprCumpleIndicador: dataMapMetaIndicador[i].idSprCumpleIndicador,
            idSprConfigIndicador: this.idSprConfigIndicador,
            //nombre: periodo[i].mes,
            cumplido: 'N',
            //fechaInicio: this.periodos[i].fechaInicioMes,
            //fechaFin: this.periodos[i].fechaFinMes,
            metaPeriodo: totalDataMetasResultados[j].metaPeriodo,
            numerador: totalDataMetasResultados[j].numerador,
            denominador: totalDataMetasResultados[j].denominador,
            estado: 1,
            usuario: this.currentUser.idSprUsuario,
            ip: this.ipAddress,
          };
          dataMetasPeriodos.push(dataMetaPeriodo)
        }
      }
    }
    for (let i = 0; i < dataMapMetaIndicador.length; i++) {
      this.cumpleIndicadorService.update(dataMetasPeriodos[i])
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId(this.modalConfigIndicador);
            this.alert.updateOk();
          },
          (err) => {
            //this.alert.updateError();
            this.alert.warning(
              '¡Atención!',
              'Exceso de actualizaciones.'
            );
          }
        );
    }
  }


  clearNameConfigIndicador() {
    this.titulosConfigIndicador[0].nombreFrecuencia = '';
    this.titulosConfigIndicador[0].nombreTipo = '';
    this.titulosConfigIndicador[0].nombreExpresion = '';
    this.titulosConfigIndicador[0].nombreUnidadMedida = '';
    this.titulosConfigIndicador[0].nombreComportamiento = '';
    this.titulosConfigIndicador[0].nombreTipoAgrupacion = '';
  }

  viewDataConfig(dataConfig: any) {
    this.titulosConfigIndicador[0].nombreTipo = dataConfig.nombreTipo;
    this.titulosConfigIndicador[0].nombreFrecuencia = dataConfig.nombreFrecuencia;
    this.titulosConfigIndicador[0].nombreExpresion = dataConfig.nombreExpresion;
    this.titulosConfigIndicador[0].nombreUnidadMedida = dataConfig.unidadMedida;
    this.titulosConfigIndicador[0].nombreComportamiento = dataConfig.comportamiento;
    this.titulosConfigIndicador[0].nombreTipoAgrupacion = dataConfig.agrupacion;
    //this.obtenerUnidadMedia(dataConfig)
    this.titulosConfigIndicador[0].formulaUnidadMedida = dataConfig.formulaUnidadMedida;
    this.identificadorUnidadMedida = this.titulosConfigIndicador[0].formulaUnidadMedida;
  }

  clearCamposConfigIndicador() {
    this.titulosConfigIndicador[0].nombreTipo = '';
    this.titulosConfigIndicador[0].nombreFrecuencia = '';
    this.titulosConfigIndicador[0].nombreExpresion = '';
    this.titulosConfigIndicador[0].nombreUnidadMedida = '';
    this.titulosConfigIndicador[0].nombreComportamiento = '';
    this.titulosConfigIndicador[0].nombreTipoAgrupacion = '';
  }

  ngOnInit(): void {
    this.nivelSelect = this.currentAmbiente.idSprNivel;
    this.initApp();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSubmit() {
    this.formSubmitted = true;
    let dataConfiguracion = {
      usuario: this.currentUser.idSprUsuario,
      ip: this.ipAddress,
      idSprConfigIndicador: this.formConfiguracionIndicadores.value.idSprConfigIndicador,
      idSprIndicador: this.idSprIndicador,
      idSprUnidadMedida: this.formConfiguracionIndicadores.value.idSprUnidadMedida,
      idSprComportamiento: this.formConfiguracionIndicadores.value.idSprComportamiento,
      idSprFrecuencia: this.formConfiguracionIndicadores.value.idSprFrecuencia,
      idSprExpresion: this.expresionCatalogo[0].idSprComun,
      idSprJerarquia: this.formConfiguracionIndicadores.value.idSprJerarquia,
      idSprTipoIndicador:  this.formConfiguracionIndicadores.value.idSprTipoIndicador,
      idSprTipoAgrupacion: this.formConfiguracionIndicadores.value.idSprTipoAgrupacion,
      lineaBase: this.formConfiguracionIndicadores.value.lineaBase,
      formula: this.formConfiguracionIndicadores.value.formula,
      estado: this.formConfiguracionIndicadores.value.estado,
    };

    // Validacion para que no guarde el tipo de agrupacion cuando la formula es 2 (No agrupado)  
     dataConfiguracion.idSprTipoAgrupacion =  dataConfiguracion.formula === "2" ? null : dataConfiguracion.idSprTipoAgrupacion;
     console.log('[INFO] dataConfiguracion: ', dataConfiguracion);
    if (this.formConfiguracionIndicadores.valid) {
      if (this.formConfiguracionIndicadores.value.idSprConfigIndicador == null || this.formConfiguracionIndicadores.value.idSprConfigIndicador == ' ') {
        this.configuracionIndicadoresService.create(dataConfiguracion)
          .pipe(
            mergeMap((dataConfigGuardada) => {
              let suscripciones = [this.crearPeriodosIndicador(dataConfigGuardada)];
              return forkJoin(suscripciones);
            })
          )
          .subscribe(
            (resp) => {
              this.initApp();
              this.closeModalIndicador();
              this.alert.createOk();
            },
            (err) => {
              this.alert.createError();
            }
          );
      } else {
        this.formConfiguracionIndicadores.value.idSprExpresion = this.expresionCatalogo[0].idSprComun;
        this.formConfiguracionIndicadores.value.idSprTipoIndicador = this.tipoIndCatalogo[0].idSprEspecialUno;
        this.configuracionIndicadoresService.update(dataConfiguracion)
          .subscribe(
            (resp) => {
              this.crearPeriodosIndicador(this.formConfiguracionIndicadores.value);
              this.initApp();
              this.closeModalIndicador();
              this.alert.updateOk();
            },
            (err) => {
              this.alert.updateError();
            }
          );
      }
      return true;
    } else {
      return false;
    }
  }


  crearPeriodosIndicador(dataConfigGuardada: any) {
    return new Promise((resolve, reject) => {
      try {
        let frecuenciaGuardada = dataConfigGuardada.idSprFrecuencia;
        let dataElementoComunes = this.dataFrecuencia;
        console.log('[INFO] dataElementoComunes: ', dataElementoComunes);
        let listFrecuencia = [];
        let dataPeriodos = [];
        let months = [];
        const date = new Date();
        const yearInit = date.getFullYear();
        let fechaInicio = `${yearInit}-01-01`;
        let fechaFinal = `${yearInit}-12-31`;
        let dateIni = new Date(fechaInicio);
        let dateFin = new Date(fechaFinal);
        let mesInicio = dateIni.getMonth()+1;
        let mesFin = dateFin.getMonth()+1;
        let year = dateIni.getFullYear();

        for (let item of dataElementoComunes) {
          if (item.idSprComun === frecuenciaGuardada) {
            listFrecuencia = item.descripcion.split(',');
            dataPeriodos = listFrecuencia.map((nombre, index) => ({
              idPeriodo: index + 1,
              nombre: nombre
            }));
            break;
          }
        }

        const addMonths = (numMonths) => {
          for (let period of dataPeriodos) {
            let fechaInicioMes = new Date(year, mesInicio, 1);
            mesInicio += numMonths;
            let fechaFinMes = new Date(year, mesInicio, 15);

            if (mesInicio > 11) {
              mesInicio -= 12;
              year += 1;
            }

            months.push({
              idPeriodo: period.idPeriodo,
              fechaInicioMes: fechaInicioMes.toISOString().split('T')[0],
              fechaFinMes: fechaFinMes.toISOString().split('T')[0]
            });
          }
        };

        switch (listFrecuencia.length) {
          case 12:
            addMonths(1);
            break;
          case 4:
            addMonths(3);
            break;
          case 3:
            addMonths(4);
            break;
          case 2:
            addMonths(6);
            break;
          case 1:
            addMonths(12);
            break;
          default:
            throw new Error("Frecuencia no válida");
        }
        this.guardarPerios(dataConfigGuardada, dataPeriodos, months)
      } catch (error) {
        reject(error);
      }
    });
  }

  guardarPerios(dataConfigGuardada: any, dataPeriodos: any, months: any) {
    let dataCumpleIndicadorSpr = []
    for (let j = 0; j < dataPeriodos.length; j++) {
      for (let k = 0; k < months.length; k++) {
        if (dataPeriodos[j].idPeriodo == months[k].idPeriodo) {
          let cumpleIndicadorSpr = {
            idSprConfigIndicador: dataConfigGuardada.idSprConfigIndicador,
            nombre: dataPeriodos[j].nombre,
            idPeriodo: dataPeriodos[j].idPeriodo,
            fechaInicio: months[k].fechaInicioMes,
            fechaFin: months[k].fechaFinMes,
            cumplido: 'N',
            estado: 1,
            usuario: this.currentUser.idSprUsuario,
            ip: this.ipAddress,
          };
          dataCumpleIndicadorSpr.push(cumpleIndicadorSpr);
        }
      }
    }

    console.log('[INFO] Dat Bulk: ', dataCumpleIndicadorSpr);
    this.cumpleIndicadorService.createBulk(dataCumpleIndicadorSpr).subscribe(
      (resp) => {
        this.initApp();
        this.closeModalIndicador();
        this.alert.createOk();
      },
      (err) => {
        this.alert.createError();
      }
    );
  }




  /* ################################################# */
  /**función subir archivo ********/
  /* ################################################# */
  public archivos: any = [];
  public nameFileGuardado: any;
  public previsualizacion: string;

  visualizarPdf(archivo: string) {
    this.cumpleIndicadorService.download(archivo).subscribe({
      next: (data) => {
        const byteCharacters = atob(data.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        FileSaver.saveAs(blob, archivo + '.pdf');
      },
      error: () => { },
    });
  }

  extraerBase64 = async ($event) =>
    new Promise((resolve, reject) => {
      try {
        const unsafeIng = window.URL.createObjectURL($event);
        const image = this.sanitizer.bypassSecurityTrustUrl(unsafeIng);
        const reader = new FileReader();
        reader.readAsDataURL($event);
        reader.onload = () => {
          resolve({
            //blob: $event,
            //image,
            base: reader.result,
          });
        };
        reader.onerror = (error) => {
          resolve({
            //blob: $event,
            //image,
            base: null,
          });
        };
      } catch (error) {
        return null;
      }
    });

  validatePdf(objPdf: any): boolean {
    let format = null;
    let response = false;
    format = objPdf.name.split('.');
    if (format[1] != 'pdf') {
      this.alert.warning(
        '¡Atención!',
        'Unicamente se puede cargar archivos .PDF'
      );
      response = true;
    }
    if (objPdf.size > this.bitesMaximoPdf) {
      this.alert.warning(
        '¡Atención!',
        'No es posible adjuntar un pdf mayor a: ' + (this.bitesMaximoPdf / 1000000).toFixed(2) + ' Mb, El pdf actual pesa: ' + (objPdf.size / 1000000).toFixed(3) + ' Mb.'
      );
      response = true;
    }
    return response;
  }

  capturarFile(event): any {
    this.formSubmitted = false;
    this.archivoCapturado = event.target.files[0];
    if (this.validatePdf(this.archivoCapturado)) {
      return false;
    } else {
      this.extraerBase64(this.archivoCapturado).then((imagen: any) => {
        this.previsualizacion = imagen.base;
      });
      this.archivos.push(this.archivoCapturado);;
    }
  }

  subirArchivo(): any {
    this.formSubmitted = true;
    if (this.archivos.length != 0) {
      try {
        const formularioDeDatos = new FormData();
        this.archivos.forEach((archivo) => {
          formularioDeDatos.append('file', archivo);
        });
        this.cumpleIndicadorService.postArchivo(formularioDeDatos, this.idSprCumpleIndicador).subscribe((responseNamePdf) => {
          this.nameFileGuardado = responseNamePdf.filename;
          this.crearCumpleIndicador();
        });
      } catch (error) {
      }
    } else {
      this.alert.warning('¡Atención!', 'No existe documento de soporte.')
      return;
    }
  }

  crearCumpleIndicador(): boolean {
    if (this.validatePdf(this.archivoCapturado)) {
      return false;
    } else {
      this.submitted = true;
      if (this.formCumpleIndicador.valid) {
        let cumpleIndicadorSpr = {
          idSprCumpleIndicador: this.idSprCumpleIndicador,
          idPeriodo: this.idPeriodoHijo,
          comentario: this.formCumpleIndicador.value.comentario,
          numerador: this.formCumpleIndicador.value.numerador,
          denominador: this.formCumpleIndicador.value.denominador,
          cumplido: 'S',
          respaldoPdf: this.nameFileGuardado,
          fechaCumplimiento: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
          estado: 1,
          usuario: this.currentUser.idSprUsuario,
          ip: this.ipAddress,
        };
        this.cumpleIndicadorService.update(cumpleIndicadorSpr).subscribe({
          next: (response) => {
            this.alert.success(
              '¡Correcto!',
              'Cumplimiento registrado correctamente.'
            );
            this.closeModalCumplirIndicador();
            this.listCumpleIndicadores();
            this.onResetFormCumpleIndicador();
          },
          error: (error) => {
            this.alert.error('¡Error!', 'Ocurrió un error, intente de nuevo.');
          },
        });
      }
      if (this.formCumpleIndicadorComentario.valid) {
        let cumpleIndicadorSpr = {
          idSprCumpleIndicador: this.idSprCumpleIndicador,
          comentario: this.formCumpleIndicadorComentario.value.comentario,
          cumplido: 'S',
          respaldoPdf: this.nameFileGuardado,
          fechaCumplimiento: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
          estado: 1,
          usuario: this.currentUser.idSprUsuario,
          ip: this.ipAddress,
        };
        this.cumpleIndicadorService.update(cumpleIndicadorSpr).subscribe({
          next: (response) => {
            this.alert.success(
              '¡Correcto!',
              'Cumplimiento registrado correctamente.'
            );
            this.closeModalCumplirIndicador();
            this.listCumpleIndicadores();
            this.onResetFormCumpleIndicador();
          },
          error: (error) => {
            this.alert.error('¡Error!', 'Ocurrió un error, intente de nuevo.');
          },
        });
      }
      if (this.formCumpleIndicadorNumerador.valid) {
        let cumpleIndicadorSpr = {
          idSprCumpleIndicador: this.idSprCumpleIndicador,
          comentario: this.formCumpleIndicadorNumerador.value.comentario,
          numerador: this.formCumpleIndicadorNumerador.value.numerador,
          cumplido: 'S',
          respaldoPdf: this.nameFileGuardado,
          fechaCumplimiento: this.pipe.transform(this.hoy, 'yyyy-MM-dd'),
          estado: 1,
          usuario: this.currentUser.idSprUsuario,
          ip: this.ipAddress,
        };
        this.cumpleIndicadorService.update(cumpleIndicadorSpr).subscribe({
          next: (response) => {
            this.alert.success(
              '¡Correcto!',
              'Cumplimiento registrado correctamente.'
            );
            this.closeModalCumplirIndicador();
            this.listCumpleIndicadores();
            this.onResetFormCumpleIndicador();
          },
          error: (error) => {
            this.alert.error('¡Error!', 'Ocurrió un error, intente de nuevo.');
          },
        });
      }
      return false;
    }
  }

  onResetFormCumplimientoIndicadorAdmin() {
    this.submitted = false;
    this.formCreaIndicadorAdmin.reset();
  }

  closeModalCumplimientoIndicadorAdmin(idModal: string = '') {
    this.modal.closeId(idModal);
    this.onResetFormCumplimientoIndicadorAdmin();
  }

  closeModalAgrupacion(idModal: string = '') {
    this.modal.closeId(idModal);
    this.submitted = false;
    this.formCreaIndicadorAdmin.reset();//verificar
  }

  crearCumplimientoIndicadorAdmin(): boolean {
    this.submitted = true;
    if (this.formCreaIndicadorAdmin.valid) {
      if (
        this.formCreaIndicadorAdmin.value.fechaInicio >
        this.formCreaIndicadorAdmin.value.fechaFin
      ) {
        this.alert.warning(
          '¡Atención!',
          'La fecha de inicio no puede ser mayor a la fecha fin.'
        );
        return false;
      }
      let cumpleIndicadorSpr = {
        idSprConfigIndicador: this.idSprConfigIndicador,
        idSprCumpleIndicador: this.formCreaIndicadorAdmin.value.idSprCumpleIndicador,
        nombre: this.formCreaIndicadorAdmin.value.periodo,
        cumplido: 'N',
        fechaInicio: this.formCreaIndicadorAdmin.value.fechaInicio,
        fechaFin: this.formCreaIndicadorAdmin.value.fechaFin,
        metaPeriodo: this.formCreaIndicadorAdmin.value.metaPeriodo,
        estado: 1,
        usuario: this.currentUser.idSprUsuario,
        ip: this.ipAddress,
      };

      if (
        cumpleIndicadorSpr.idSprCumpleIndicador == null ||
        cumpleIndicadorSpr.idSprCumpleIndicador == ' '
      ) {
        this.cumpleIndicadorService.list(`?idSprConfigIndicador=${this.idSprConfigIndicador}&nombre=${this.formCreaIndicadorAdmin.value.periodo}`)
          .subscribe({
            next: (response) => {
              if (response.length > 0) {
                this.alert.warning(
                  '¡Atención!',
                  'No se puede crear, registro ya existe.'
                );
                return false;
              } else {
                this.cumpleIndicadorService
                  .create(cumpleIndicadorSpr)
                  .subscribe(
                    (resp) => {
                      this.initApp();
                      this.modal.closeId(this.modalIngresoMetas);
                      this.alert.createOk();
                      this.listCumpleIndicadores();
                    },
                    (err) => {
                      this.alert.createError();
                    }
                  );
              }
              return false;
            },
            error: (error) => { },
          });
      } else {
        // Actualizar registro
        this.cumpleIndicadorService
          .list(
            `?idSprConfigIndicador=${this.idSprConfigIndicador}&nombre=${this.formCreaIndicadorAdmin.value.periodo}`
          )
          .subscribe({
            next: (response) => {
              if (
                response.length == 1 &&
                response[0].idSprCumpleIndicador ==
                this.formCreaIndicadorAdmin.value.idSprCumpleIndicador
              ) {
                this.cumpleIndicadorService
                  .update(cumpleIndicadorSpr)
                  .subscribe(
                    (resp) => {
                      this.initApp();
                      this.modal.closeId(this.modalIngresoMetas);
                      this.alert.updateOk();
                    },
                    (err) => {
                      this.alert.updateError();
                    }
                  );
                return true;
              } else if (response.length == 0) {
                this.cumpleIndicadorService
                  .update(cumpleIndicadorSpr)
                  .subscribe(
                    (resp) => {
                      this.initApp();
                      this.modal.closeId(this.modalIngresoMetas);
                      this.alert.updateOk();
                    },
                    (err) => {
                      this.alert.updateError();
                    }
                  );
                return true;
              } else {
                this.alert.warning(
                  '¡Atención!',
                  'No se puede actualizar, registro ya existe.'
                );
                return false;
              }
            },
            error: (error) => { },
          });
      }
      return true;
    } // Fin if validación de form
    return false;
  }

  edit(obj: any) {

    this.openModal();
    if ((this.dataMapCumpleIndicador.length > 0) || (this.dataMapAgrupacionIndicador.length > 0)) {
      this.dasactivarCamposFormConfig = true;
      this.disableSelect = new FormControl(this.dasactivarCamposFormConfig);
      this.alert.warning(
        '¡Atención!',
        'No se puede editar... Debe eliminar los periodos creados, para acceder a la edición.'
      );
    } else {
      this.dasactivarCamposFormConfig = false;
      this.disableSelect = new FormControl(this.dasactivarCamposFormConfig);
    }
    this.formConfiguracionIndicadores.patchValue({
      idSprConfigIndicador: obj.idSprConfigIndicador,
      idSprIndicador: obj.idSprIndicador,
      nombreFrecuencia: obj.nombreFrecuencia,
      idSprUnidadMedida: obj.idSprUnidadMedida,
      idSprComportamiento: obj.idSprComportamiento,
      idSprExpresion: obj.idSprExpresion,
      idSprFrecuencia: obj.idSprFrecuencia,
      idSprJerarquia: obj.idSprJerarquia,
      idSprTipoIndicador: obj.idSprTipoIndicador,
      lineaBase: obj.lineaBase,
      formula: obj.formula,
      idSprTipoAgrupacion: obj.idSprTipoAgrupacion,
      estado: obj.estado,
    });
  }


  editAgrupacion(obj: any) {
    this.openModalFormularioAgrupacion();
    this.formAgrupacionIndicador.patchValue({
      idSprAmbiente: obj.idSprAmbiente,
      idSprObjetivo: obj.idSprObjetivo,
      idSprAgrupaIndicador: obj.idSprAgrupaIndicador,
      idSprIndicadorPadre: obj.idSprIndicadorPadre,
      idSprIndicadorHijo: obj.idSprIndicadorHijo,
      idSprTipoAgrupacionCalculo: obj.idSprTipoAgrupacionCalculo,
      valor: obj.valor,
      estado: obj.estado,
    });
  }

  editMetaPerido(obj: any) {
    this.openModalEditMetas();
    this.formCreaIndicadorAdmin.patchValue({
      idSprCumpleIndicador: obj.idSprCumpleIndicador,
      metaPeriodo: obj.metaPeriodo,
      idPeriodo: obj.idPeriodo,
      nombrePeriodo: obj.nombre,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      estado: obj.estado,
    });
  }

  deleteConfigIndicador(idRegister: number) {
    this.modal.open('delete-config-indicador');
    this.id_SprCumpleIndicador = idRegister;
    this.cumpleIndicadorService.list('?idSprConfigIndicador=' + this.id_SprCumpleIndicador).subscribe(
      resp => {
        this.respDataPeriodosCumple = resp
      }
    )
  }

  confirmDelete(deleteId: string = 'delete') {
    if (this.respDataPeriodosCumple.length > 0) {
      this.spinner.show();

      const deleteRequests = this.respDataPeriodosCumple.map(periodo => (
 // return this.cumpleIndicadorService.delete(
    {
      idSprCumpleIndicador: periodo.idSprCumpleIndicador,
      usuario: this.currentAmbiente.idSprUsuario,
      delLog: 'S',
       estado: 1,
      ip: this.ipAddress,
    }));


      // Borrar todos los cumpleIndicador asociados al configIndicador
      this.cumpleIndicadorService.deleteBulk(deleteRequests).subscribe(
      (resp) => {
            this.configuracionIndicadoresService.delete({
            idSprConfigIndicador: this.id_SprCumpleIndicador,
            usuario: this.currentAmbiente.idSprUsuario,
            delLog: 'S',
            ip: this.ipAddress,
          }).subscribe({
            next: () => {
              this.dasactivarCamposFormConfig = false;        
              this.spinner.hide();
              this.modal.closeId(deleteId);
              this.initApp();
              this.alert.deleteOk();
            },
            error: () => {
              this.alert.deleteError();
            }
          });


      },
      (err) => {
       this.alert.updateError();
      }
    );
    
      // const deleteRequests = this.respDataPeriodosCumple.map(periodo => {
      //   return this.cumpleIndicadorService.delete({
      //     idSprCumpleIndicador: periodo.idSprCumpleIndicador,
      //     usuario: this.currentAmbiente.idSprUsuario,
      //     delLog: 'S',
      //     ip: this.ipAddress,
      //   });
      // });

    //   forkJoin(deleteRequests).pipe(
    //     finalize(() => {
    //       this.spinner.hide();
    //       this.modal.closeId(deleteId);
    //     })
    //   ).subscribe({
    //     next: () => {
    //       this.configuracionIndicadoresService.delete({
    //         idSprConfigIndicador: this.id_SprCumpleIndicador,
    //         usuario: this.currentAmbiente.idSprUsuario,
    //         delLog: 'S',
    //         ip: this.ipAddress,
    //       }).subscribe({
    //         next: () => {
    //           this.dasactivarCamposFormConfig = false;
    //           this.initApp();
    //           this.alert.deleteOk();
    //         },
    //         error: () => {
    //           this.alert.deleteError();
    //         }
    //       });
    //     },
    //     error: () => {
    //       this.alert.deleteError();
    //     }
    //   });
    // } else {
    //   this.modal.closeId(deleteId);
    }
  }

  deleteCumpleIndicador(idRegister: number) {
    this.modal.open('delete-cumple-indicador');
    this.idDeleteRegister = idRegister;
  }

  confirmDeleteCumpleIndicador(deleteId: string = 'delete') {

    if (this.idDeleteRegister > 0) {
      this.cumpleIndicadorService
        .delete({
          idSprCumpleIndicador: this.idDeleteRegister,
          usuario: this.currentAmbiente.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId(deleteId);
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    }
  }


  delete(idRegister: number) {
    this.idDeleteRegister = idRegister;
    this.modal.open('elimina-Agrupacion');
  }

  deleteAgrupacion(idRegister: number) {
    this.idDeleteRegister = idRegister;
    this.modal.open(this.eliminaAgrupacionIndicador);
  }

  confirmDeleteAgrupacion() {
    if (this.idDeleteRegister > 0) {
      this.agrupacionIndicadoresService.delete({
        idSprAgrupaIndicador: this.idDeleteRegister,
        usuario: this.currentAmbiente.idSprUsuario,
        delLog: 'S',
        ip: this.ipAddress,
      })
        .subscribe(
          (resp) => {
            this.listAgrupacionIndicadores();
            this.modal.closeId(this.eliminaAgrupacionIndicador);
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    }
  }


  listFrecuencia() {
    let frecuencia: string;
    let frecuenciaA: any[];
    this.comunService.list().subscribe((resp) => {
      this.dataFrecuencia = this.getDataDependiente(
        resp,
        this.idSprComunCatalogoFrecuencia
      );
      frecuencia = this.dataFrecuencia[0].descripcion;
      frecuenciaA = frecuencia.split(',');
    });
  }

  getDataDependiente(dataObj: any, spr_idSprComun: any = null) {
    let stateOptionTipo = false;
    let dependientes: any = [];
    dataObj.forEach((row: any) => {
      if (row.spr_idSprComun == spr_idSprComun) {
        dependientes.push({
          idSprComun: row.idSprComun,
          nombre: row.nombre,
          descripcion: row.descripcion,
          spr_idSprComun: row.spr_idSprComun,
          estado: row.estado,
        });
      }
    });
    return dependientes;
  }


  getDataDependienteEspecialUno(
    dataObj: any,
    spr_idSprEspecialUno: any = null
  ) {
    let stateOptionTipo = false;
    let dependientes: any = [];
    dataObj.forEach((row: any) => {
      if (row.spr_idSprEspecialUno == spr_idSprEspecialUno) {
        dependientes.push({
          idSprEspecialUno: row.idSprEspecialUno,
          nombre: row.nombre,
          descripcion: row.descripcion,
          ponderacion: row.ponderacion,
          spr_idSprEspecialUno: row.spr_idSprEspecialUno,
          estado: row.estado,
        });
      }
    });
    return dependientes;
  }

  listTipoAgrupacion() {
    this.especialDosService.list('?spr_idSprEspecialDos=' + this.idSprTipoAgrupacionEspecialDos)
      .subscribe(resp => {
        this.dataTipoAgrupacion = resp;
      })
  }

  // Modal Crear/editar
  openModal() {
    this.onResetForm();
    this.modal.open(this.modalConfigIndicador);
    this.dasactivarCamposFormConfig = false;
    this.disableSelect = new FormControl(this.dasactivarCamposFormConfig);
  }

  openModalAgrupaIndicadores(rowConfigIndicador: any) {
    this.formSubmitted = false;
    this.dataObjetivo = [0];
    this.dataIndicadorInferior = [0]
    let dataObjetivoEstrategia = []
    this.idSprIndicadorPadre = rowConfigIndicador.idSprIndicador
    this.idSprTipoAgrupacionCalculo = rowConfigIndicador.idSprTipoAgrupacion
    if (rowConfigIndicador.idSprIndicador) {
      this.indicadoresService.list(`${rowConfigIndicador.idSprIndicador}`).subscribe(data => {
        for (let i = 0; i < this.dataEstrategiaObjetivo.length; i++) {
          if ((this.dataEstrategiaObjetivo[i].idSprObjetivo == data.idSprObjetivo) &&
            (this.dataEstrategiaObjetivo[i].nivelSuperior == "N")) {
            dataObjetivoEstrategia.push({
              idSprEstrategiaPadre: this.dataEstrategiaObjetivo[i].idSprEstrategia,
            })
          }
        }
        this.dataObjetivoEstrategiaPadre = dataObjetivoEstrategia;
      }
      )
    }
    this.obtenerTipoAgrupacion(this.idSprTipoAgrupacionCalculo)
    this.listAgrupacionIndicadores()
    this.formAgrupacionIndicador.reset();
    this.modal.open(this.modalAgrupaIndicadores);
  }

  closeModalAgrupaIndicadores() {
    this.modal.closeId(this.modalAgrupaIndicadores);
  }

  openModalFormularioAgrupacion() {
    this.formAgrupacionIndicador.reset();//verificar
    this.modal.open(this.modalFormularioAgrupacion);
  }
  closeModalFormularioAgrupacion() {
    this.modal.closeId(this.modalFormularioAgrupacion);
    this.submitted = false;
  }

  openModalSetCumpleIndicadores(rowConfigIndicador: any) {
    let idSprIndicadorPadre: number;
    this.dataReplicaIndicadores = [0];
    console.log('[INFO] ', rowConfigIndicador);
    this.lineaBaseMetaIndicador = rowConfigIndicador.lineaBase || "0.00";

      if(rowConfigIndicador.unidadMedida != null && rowConfigIndicador.unidadMedida === 'TIEMPO'){
      console.log('[INFO] Unidad de mediad es TIEMPO');
      }


    for (let i = 0; i < this.dataMapCumpleIndicador.length; i++) {
      if (this.dataMapCumpleIndicador[0].metaPeriodo != null) {
        this.dasactivarCamposFormMeta = true;
        this.alert.warning(
          '¡Atención!',
          'No se puede editar... Ya existen metas creadas.'
        );
      } else {
        this.dasactivarCamposFormMeta = false;
      }
    }

    this.formCreaIndicadorAdmin.patchValue({
      idSprCumpleIndicador: rowConfigIndicador.idSprCumpleIndicador,
      periodo: rowConfigIndicador.nombre,
      fechaInicio: rowConfigIndicador.fechaInicio,
      fechaFin: rowConfigIndicador.fechaFin,
      metaPeriodo: rowConfigIndicador.metaPeriodo,
    });
    this.idSprConfigIndicador = rowConfigIndicador.idSprConfigIndicador;
    idSprIndicadorPadre = rowConfigIndicador.idSprIndicador;
    this.nombreIndicador = rowConfigIndicador.nombre;

    if (this.idSprIndicadorPadre > 0) {
      this.listAgrupacionIndicadores()
    }
    this.modal.open(this.modalIngresoMetas);
  }

public esTipoTiempo:boolean = false;
public metaPeriodoCumpleIndicador:string;
  openModalCumplirIndicador(row: any) {
    const esTIpoPeriodoArreglo = row.metaPeriodo?.toString().split(':');
    this.esTipoTiempo = esTIpoPeriodoArreglo.length === 3 ? true : false;
    console.log('[INFO] openModalCumplirIndicador: ', row);
    this.submitted = false;
    this.formCumpleIndicador.reset();
    let fechaActual;
    fechaActual = this.pipe.transform(this.hoy, 'yyyy-MM-dd');
    this.cumplimientoIndicador = row.nombre + '    [' + row.fechaInicio + ' - ' + row.fechaFin + ']';
    this.metaPeriodoCumpleIndicador = row.metaPeriodo;
    this.idSprCumpleIndicador = row.idSprCumpleIndicador;
    this.idPeriodoHijo = row.idPeriodo;
    //this.modal.open(this.modalCumpleIndicadorNumDeno);

    if (row.metaPeriodo != null) {
      if (this.dataMapConfigIndicador.length > 0) {
        if (this.dataMapConfigIndicador[0].formula == 1) {
          if (row.fechaFin >= fechaActual) {
            this.modal.open(this.modalCumpleIndicadorComentario);
          } else {
            this.alert.warning('¡Atención!', 'Fecha fuera de vigencia.')
          }
        }
      }

      if (this.dataMapConfigIndicador.length > 0) {
        if ((this.dataMapConfigIndicador[0].formula == 2) || (this.dataMapConfigIndicador[0].formula == null)) {
          if ((this.identificadorUnidadMedida == 'PORCENTAJE') || (this.identificadorUnidadMedida == 'BANDA')) {
            if (row.fechaFin >= fechaActual) {
              this.modal.open(this.modalCumpleIndicadorNumDeno);
            } else {
              this.alert.warning('¡Atención!', 'Fecha fuera de vigencia.')
            }
          } else {
            if (row.fechaFin >= fechaActual) {
              this.modal.open(this.modalCumpleIndicadorNumerador);
            } else {
              this.alert.warning('¡Atención!', 'Fecha fuera de vigencia.')
            }
          }
        }
      }
    } else {
      if (this.dataMapConfigIndicador[0].formula == 2) {
        this.alert.warning(
          '¡Atención!',
          'No se puede acceder... No existen metas creadas.'
        );
      } else {
        this.alert.warning(
          '¡Atención!',
          'No se puede acceder... Previamente actualizar metas/resultados.'
        );
      }

    }
  }

  closeModalCumplirIndicador() {
    this.onResetFormCumpleIndicador();
    this.resetArchivo();
    this.modal.closeId(this.modalCumpleIndicadorComentario);
    this.modal.closeId(this.modalCumpleIndicadorNumDeno);
    this.modal.closeId(this.modalCumpleIndicadorNumerador);
  }

  resetArchivo() {
    this.myInputVariable.nativeElement.value = "";
    this.archivos = []
  }

  openModalEditMetas() {
    this.modal.open(this.modalEditMetas);

  }

  onResetForm() {
    this.formSubmitted = false;
    this.formConfiguracionIndicadores.reset();
  }

  onResetFormCumpleIndicador() {
    this.formSubmitted = false;
    this.formCumpleIndicador.reset();
    this.formCumpleIndicadorComentario.reset();
    this.formCumpleIndicadorNumerador.reset();
  }
  closeModalIndicador() {
    this.modal.closeId(this.modalConfigIndicador);
  }

  isInvalid = false;

allowHourOrNumber(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;
  const char = event.key;

  // Permitir navegación y borrado
  if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(char)) {
    return;
  }

  // Solo permitir números, coma, punto y dos puntos
  const allowedChars = ['0','1','2','3','4','5','6','7','8','9','.',',',':'];
  if (!allowedChars.includes(char)) {
    event.preventDefault();
    return;
  }

  const newValue = input.value + char;

  // Si incluye ":", validar que cumpla estructura HH:MM:SS
  if (newValue.includes(':')) {
    const parts = newValue.split(':');

    // No permitir más de 3 secciones
    if (parts.length > 3) {
      event.preventDefault();
      return;
    }

    // Cada sección máximo 2 caracteres
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].length > 2) {
        event.preventDefault();
        return;
      }
    }

    // Validar valores válidos de hora (00–23) y minutos/segundos (00–59)
    if (parts.length === 3) {
      const [h, m, s] = parts.map(p => parseInt(p || '0', 10));
      if (h > 23 || m > 59 || s > 59) {
        event.preventDefault();
      }
    }
  }
}

validateNumberOrTime() {
  const val = this.formConfiguracionIndicadores.get('lineaBase')?.value?.trim() ?? '';

  // permitir número decimal o formato HH:mm:ss
  const numberRegex = /^[0-9]+([.,][0-9]+)?$/;
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

  const valid = numberRegex.test(val) || timeRegex.test(val);

  this.isInvalid = val.length > 0 && !valid;
  this.formConfiguracionIndicadores.get('lineaBase')?.setErrors(this.isInvalid ? { invalidValue: true } : null);
}

validarHora(event: any) {
  const valor = event.target.value;
  const regexHora = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

  if (!regexHora.test(valor)) {
      this.alert.warning('¡Atención!', 'Formato de hora erroneo: usa 23:59:59 (HH:MM:SS)');

    //alert('Formato de hora inválido. Usa HH:MM:SS (00:00:00 - 23:59:59)');
    event.target.focus(); 
    //event.target.value = ''; // Limpia el campo si no cumple
  }
}
}
